/* Varianten-Karten ohne Preis (App-Vorlage "Text neben Bild"): Preis aus dem verlinkten Produkt nachladen */
(function () {
  'use strict';
  var cache = {};
  function euro(c) { return '\u20ac' + (c / 100).toFixed(2).replace('.', ','); }
  function preise() {
    document.querySelectorAll('.swatch-view-image .swatch-image[swatch-url]').forEach(function (s) {
      if (s.querySelector('.swatch-price-adjacent, .ct-swatch-preis')) return;
      var url = s.getAttribute('swatch-url');
      if (!url) return;
      var platz = document.createElement('span');
      platz.className = 'ct-swatch-preis';
      s.appendChild(platz);
      (cache[url] = cache[url] || fetch(url.split('?')[0] + '.js').then(function (r) { return r.json(); }))
        .then(function (p) {
          var v = p.variants && p.variants[0];
          if (!v) return;
          platz.textContent = euro(v.price);
          if (v.compare_at_price && v.compare_at_price > v.price) {
            var d = document.createElement('del'); d.textContent = euro(v.compare_at_price); platz.appendChild(d);
          }
        }).catch(function () {});
    });
  }
  function los() {
    preise();
    var z = 0, mo = new MutationObserver(function () { clearTimeout(z); z = setTimeout(preise, 80); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();
